const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' }

function formatDatetime(date: string | undefined) {
  if (!date)
    return '-'
  const dateObj = new Date(date)
  return `${dateObj.toLocaleDateString('de-DE', options)} ${dateObj.toLocaleTimeString('de-DE')}`
}

function formatDate(date: Date | undefined) {
  if (!date)
    return '-'
  const dateObj = new Date(date)
  return dateObj.toLocaleDateString('de-DE', options)
}

// these APIs are auto-imported from @vueuse/core
export const filter = {
  formatDatetime,
  formatDate,
}
